module.exports = __webpack_public_path__ + "media/flags/sg-cef0bd55.svg";